// Libs
import { isNil } from "lodash";
// Redux - types
import { StoreNotificationTypes } from "../notification/types";
import { StoreUserTypes } from "../user/types";
// Contenedor dependencias
import container from "../../../modules/Shared/container";
// Selectores
import { selectUserToken } from "../selectors";
// Saga
import { select, put, takeLatest } from "redux-saga/effects";

/**
 * Logamos usuario en servidor
 */
function* loginUserInServer({ payload }: any): any {
  try {
    // Payload data
    const { email, password } = payload;
    // Api
    const authRepository = container.resolve("authRepository");
    // User
    const loggedUser = yield authRepository.loginAuth(email, password);
    // Reset user in store
    yield put({ type: StoreUserTypes.RESET_USER });
    // Set user in store
    yield put({
      type: StoreUserTypes.SET_USER,
      payload: loggedUser,
    });
  } catch (err: any) {
    // Show error
    yield put({
      type: StoreNotificationTypes.SET_NOTIFICATION,
      payload: {
        show: true,
        text: err.message,
      },
    });
  }
}

/**
 * Actualizamos datos del usuario en el servidor API
 */
function* setUserInServer({ payload }: any): any {
  try {
    // user token
    const userToken = yield select(selectUserToken);
    // Payload data
    const { password, ...params } = payload;
    // Api
    const authRepository = container.resolve("authRepository");

    // Save in server
    yield authRepository.updateUser(
      {
        ...params,
        ...(!isNil(password) ? { password } : {}),
      },
      {
        headers: {
          Authorization: `Bearer ${userToken as string}`,
        },
      },
    );
    // Change state in store
    yield put({
      type: StoreUserTypes.SET_USER,
      payload: params,
    });
  } catch (err: any) {
    // Show error
    yield put({
      type: StoreNotificationTypes.SET_NOTIFICATION,
      payload: {
        show: true,
        text: err.message,
      },
    });
  }
}

// Watcher functions
export function* loginUserInServerTakeLatest(): any {
  yield takeLatest(StoreUserTypes.LOGIN_USER_IN_SERVER, loginUserInServer);
}

export function* setUserInServerTakeLatest(): any {
  yield takeLatest(StoreUserTypes.SET_USER_IN_SERVER, setUserInServer);
}
